<template>
  <div>
    <aha-antd-button
      class="import-button"
      variant="secondary"
      size="lg"
      @click="onClickPresentationListImportButton"
      v-aha-emit-action
      name="presentation-list-import-button"
      v-tooltip="$i18nPresenter.t('Import')"
    >
      <div class="flex items-center gap-2">
        <aha-icon
          v-if="!isUploadingOrImportingSlides"
          name="upload-simple"
          width="16"
          height="16"
          viewBox="0 0 32 32"
          maintainColor
          class="import-button-icon"
        />
        <aha-spinner v-if="isUploadingOrImportingSlides" />
        <span class="import-button-text">
          {{ $i18nPresenter.t("Import") }}
        </span>
      </div>
    </aha-antd-button>
    <aha-toggle-tip v-if="tooltipProps" v-bind="tooltipProps" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UploadingTooltipMixin from '@/mixins/UploadingTooltipMixin'

export default {
  name: 'PresentationListImportButtonV2',

  mixins: [UploadingTooltipMixin],

  data() {
    return {
      // tooltipProps and tooltipCallId will be merged from mixin
      tooltipPlacement: 'top',
      tooltipTarget: 'presentation-list-import-button',
    }
  },

  computed: {
    ...mapGetters('aiChatbotImportPptxPdf', [
      'isUploadingOrImportingSlides',
    ]),
  },

  methods: {
    ...mapActions('aiChatbotImportPptxPdf', ['setIsAIChatbotImportModalVisibleV2Action']),

    onClickPresentationListImportButton() {
      this.setIsAIChatbotImportModalVisibleV2Action(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.import-button {
  @apply text-base font-normal text-gray-100;
  svg.import-button-icon:not(:hover) {
    &:deep(path) {
      stroke: var(--color-gray-90, #4A4A4A);
    }
  }
  &:hover {
    svg.import-button-icon {
      &:deep(path) {
        stroke: var(--color-primary, #6A1EBB);
      }
    }
  }
}
</style>
